import { render, staticRenderFns } from "./UnderNumber.vue?vue&type=template&id=54c2dae7&"
import script from "./UnderNumber.vue?vue&type=script&lang=js&"
export * from "./UnderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports